const enum PATH {
    HOME = '/'
}

export default PATH;